/* (ignored) */


//////////////////
// WEBPACK FOOTER
// min-document (ignored)
// module id = 2911
// module chunks = 0